import JourneyDnDContainer, {
    JOURNEY_DND_CONTAINER_WHICH_VIEW
} from "../../../container/journey/journey-dnd-container/JourneyDnDContainer";
import {useAppSelector} from "../../../redux/reducer/store";
import './styles.css'
import TopButtonsWrapper from "../../../components/button-groups/top-buttons-wrapper/TopButtonsWrapper";
import React, {useEffect, useState} from "react";
import DownloadPdfButton from "../../../container/buttons/download-pdf-button/DownloadPdfButton";
import CopyToClipboardButton from "../../../container/buttons/copy-to-clipboard-button/CopyToClipboardButton";
import {getDurationInDaysOrNights} from "../../../utils/getter/common";
import {BundleType} from "../../../container/buttons/common";
import DeleteBundlesButton from "../../../container/buttons/delete-bundles-button/DeleteBundlesButton";
import {isEqual} from "lodash";
import {DEFAULT_JOURNEY} from "../../../redux/reducer/journey";
import {PATH_STRINGS} from "../../../routes/route-props";
import {Navigate, useLocation} from "react-router-dom";
import LoadBundlesButton from "../../../container/buttons/load-bundles-button/LoadBundlesButton";
import SaveBundlesButton from "../../../container/buttons/save-bundles-button/SaveBundlesButton";
import useFirstRender from "../../../hooks/use-first-render";

const EditJourney = () => {
    const {
        bundleId,
        name,
        description,
        activities: journeyActivities,
        customer,
        journeyDuration,
        personCount,
    } = useAppSelector(state => state.journey)
    const {activities: travelComponentActivities} = useAppSelector(state => state.travelComponents)
    const {blockCalculationViaSiteTitle} = useAppSelector(state => state.settings)
    const [bundleHasBeenLoaded, setBundleHasBeenLoaded] = useState(false)
    const journeyDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
    const location = useLocation()
    const isFirstRender = useFirstRender()

    useEffect(() => {
        if (location?.state?.scrollToDay && isFirstRender) {
            const container = document.querySelector(".journey-overview-container")
            const element = document.getElementById(location.state.scrollToDay)

            if (element && container) {
                const rect = element.getBoundingClientRect()
                const containerRect = container.getBoundingClientRect()

                // Check if the element is out of the container's viewport
                const isOutOfView = rect.top < containerRect.top || rect.bottom > containerRect.bottom
                if (isOutOfView) {
                    container.scrollTo({
                        top: rect.top - containerRect.top + container.scrollTop, // This aligns the element to the top of the container
                        behavior: "smooth",
                    });
                }
            }
        }
    }, [location])

    useEffect(() => {
        setBundleHasBeenLoaded(bundleId !== null)
    }, [bundleId])

    const _renderEditJourney = () => <>
        <TopButtonsWrapper
            rightButtons={<>
                {journeyDurationInDays !== null && <>
                    <DownloadPdfButton
                        activities={journeyActivities}
                        whatPdfToCreate={BundleType.journey}
                    />
                    <CopyToClipboardButton
                        whatToCopy={BundleType.journey}
                        activities={journeyActivities}/>
                    <LoadBundlesButton
                        showBundleIcon={false}
                        whatToLoad={BundleType.journey}/>
                </>}
                <SaveBundlesButton
                    bundleHasBeenLoaded={bundleHasBeenLoaded}
                    whatToSave={BundleType.journey}
                    activities={journeyActivities}
                />
                <DeleteBundlesButton whatToDelete={BundleType.journey}/>
            </>}
        />
        <JourneyDnDContainer
            journeyPersonCount={personCount}
            travelComponentActivities={travelComponentActivities}
            allowCalculation={!blockCalculationViaSiteTitle}
            whichView={JOURNEY_DND_CONTAINER_WHICH_VIEW.journeyOverview}
            activities={journeyActivities}
            journeyDuration={journeyDuration}/>
    </>

    const _renderPage = () => {
        if (isEqual({
            bundleId,
            name,
            description,
            activities: journeyActivities,
            customer,
            journeyDuration,
            personCount,
        }, DEFAULT_JOURNEY)) return <Navigate
            to={PATH_STRINGS.newJourney} replace={true}/>
        return _renderEditJourney()
    }

    return _renderPage()
}

export default EditJourney